
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("hIyMe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e9e9d8d02793ed63$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7fSR6 = parcelRequire("7fSR6");

var $k8Qyf = parcelRequire("k8Qyf");

var $gd0Sp = parcelRequire("gd0Sp");


var $6N0K8 = parcelRequire("6N0K8");

var $7cv9E = parcelRequire("7cv9E");
/**
 * Ensures the visibility of a custom theme notification for site administrators. This involves determining
 * the appropriateness of displaying a notification based on the admin's status, theme customization, and
 * whether the notification has previously been dismissed.
 */ const $e9e9d8d02793ed63$var$useCustomThemeAdminFlag = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $k8Qyf.useFlagsService)();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [isFlagDismissed, setIsFlagDismissed] = (0, $eUqFw.useState)(undefined);
    const [{ navigationTheme: navigationTheme }] = (0, $7fSR6.useTheme)();
    const handleDismiss = (0, $eUqFw.useCallback)(()=>{
        if (hasFlag?.((0, $87949aabb9428743$export$27067257403b6ec2))) {
            dismissFlag((0, $87949aabb9428743$export$27067257403b6ec2));
            setIsFlagDismissed(true);
            (0, $6N0K8.setAdminFlagDismissed)(true);
        }
    }, [
        dismissFlag,
        hasFlag
    ]);
    const handleShowFlag = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            id: (0, $87949aabb9428743$export$27067257403b6ec2),
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cv9E.default), {
                    ...props,
                    onDismiss: handleDismiss,
                    analyticsAttributes: {
                        backgroundColor: navigationTheme.backgroundColor,
                        highlightColor: navigationTheme.highlightColor
                    }
                })
        });
    }, [
        handleDismiss,
        showFlag,
        navigationTheme
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (tenantContext.isSiteAdmin && navigationTheme.usesCustomColours && isFlagDismissed === undefined && !hasFlag?.((0, $87949aabb9428743$export$27067257403b6ec2))) (0, $6N0K8.fetchAdminFlagDismissed)().then((result)=>{
            setIsFlagDismissed(result || false);
        });
    }, [
        tenantContext,
        navigationTheme,
        isFlagDismissed,
        hasFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isFlagDismissed === false) handleShowFlag();
    }, [
        handleShowFlag,
        isFlagDismissed
    ]);
    return null;
};
var $e9e9d8d02793ed63$export$2e2bcd8739ae039 = $e9e9d8d02793ed63$var$useCustomThemeAdminFlag;

});
const $87949aabb9428743$export$6ce8ce08d5cfc78d = 'jira.user.theme.custom-nav-bar-admin-flag.dismissed';
const $87949aabb9428743$export$27067257403b6ec2 = 'jira.user.theme.custom-nav-bar-admin-flag.id';

parcelRegister("6N0K8", function(module, exports) {

$parcel$export(module.exports, "setAdminFlagDismissed", () => $18255f5e21adf6dd$export$8ac022716e1b44d2);
$parcel$export(module.exports, "fetchAdminFlagDismissed", () => $18255f5e21adf6dd$export$86466cb5fba8df96);

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

const $18255f5e21adf6dd$export$8ac022716e1b44d2 = async (value)=>{
    try {
        await (0, $cm5m0.userPreferenceAPI).set((0, $87949aabb9428743$export$6ce8ce08d5cfc78d), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'setCustomThemeAdminFlagDismissed',
                packageName: 'jiraCustomThemeAdminFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $18255f5e21adf6dd$export$86466cb5fba8df96 = async ()=>{
    try {
        return await (0, $cm5m0.userPreferenceAPI).get((0, $87949aabb9428743$export$6ce8ce08d5cfc78d));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (err.statusCode !== 404) // 404 is acceptable as it means user hasn't dismissed it yet
        (0, $guiFP.default)({
            error: err,
            meta: {
                id: 'fetchCustomThemeAdminFlagDismissed',
                packageName: 'jiraCustomThemeAdminFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};

});

parcelRegister("7cv9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $779b4180c858d34b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2bv8J = parcelRequire("2bv8J");

var $PdmhA = parcelRequire("PdmhA");

var $kQ0RL = parcelRequire("kQ0RL");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");


var $6elE6 = parcelRequire("6elE6");
const $779b4180c858d34b$export$75cd6a37cd391e2e = 'custom-theme-admin-flag-test-id';
const $779b4180c858d34b$export$8f3f1db68a140845 = '/secure/admin/LookAndFeel!default.jspa';
const $779b4180c858d34b$var$HELP_ARTICLE_ID = '1QC8AUgw7MAmoVtoYXQDxM';
const $779b4180c858d34b$var$CustomThemeAdminFlag = ({ onDismiss: onDismiss, analyticsAttributes: analyticsAttributes })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onOpenInProductHelpArticle = (0, $3QLcd.useHelpPanelLink)();
    return (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.InfoFlag), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
                primaryColor: `var(--ds-icon-information, ${(0, $PdmhA.B200)})`,
                label: ""
            }),
            testId: $779b4180c858d34b$export$75cd6a37cd391e2e,
            id: (0, $87949aabb9428743$export$27067257403b6ec2),
            title: formatMessage((0, $6elE6.default).flagHeader),
            description: formatMessage((0, $6elE6.default).flagBody),
            onDismissed: (_, analyticsEvent)=>{
                onDismiss();
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'customTopNavAdminFlagWarningDismissButton', analyticsAttributes);
            },
            actions: [
                {
                    content: formatMessage((0, $6elE6.default).revertButton),
                    href: $779b4180c858d34b$export$8f3f1db68a140845,
                    target: '_blank',
                    onClick: (_, analyticsEvent)=>{
                        onDismiss();
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'customTopNavAdminFlagWarningRevertButton', analyticsAttributes);
                    }
                },
                {
                    content: formatMessage((0, $6elE6.default).learnMoreButton),
                    onClick: (_, analyticsEvent)=>{
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'customTopNavAdminFlagWarningMoreButton', analyticsAttributes);
                        onOpenInProductHelpArticle?.($779b4180c858d34b$var$HELP_ARTICLE_ID);
                    }
                }
            ]
        }), [
        formatMessage,
        onDismiss,
        onOpenInProductHelpArticle,
        analyticsAttributes
    ]);
};
var $779b4180c858d34b$export$2e2bcd8739ae039 = $779b4180c858d34b$var$CustomThemeAdminFlag;

});
parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = $1974c390fcca76c2$var$InfoIcon;
module.exports.default = $1974c390fcca76c2$var$_default;

});

parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});


parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $bbdYy = parcelRequire("bbdYy");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $bbdYy.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $bbdYy.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $bbdYy.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;

});
parcelRegister("bbdYy", function(module, exports) {

$parcel$export(module.exports, "ARTICLE_TYPE", () => $823b900fea2e703d$export$a72bfd9b1e5592c8);
let $823b900fea2e703d$export$a72bfd9b1e5592c8 = /*#__PURE__*/ function(ARTICLE_TYPE) {
    ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
    ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
    return ARTICLE_TYPE;
}({});

});


parcelRegister("6elE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea40bbf32572539b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea40bbf32572539b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    flagHeader: {
        "id": "custom-theme-admin-flag.flag-header",
        "defaultMessage": "Review your custom colors"
    },
    flagBody: {
        "id": "custom-theme-admin-flag.flag-body",
        "defaultMessage": "You've customized the look and feel of your Jira. Some people may notice mismatched colors when using the new dark theme."
    },
    revertButton: {
        "id": "custom-theme-admin-flag.revert-button",
        "defaultMessage": "Revert custom colors"
    },
    learnMoreButton: {
        "id": "custom-theme-admin-flag.learn-more-button",
        "defaultMessage": "Learn more"
    }
});

});




//# sourceMappingURL=async-custom-theme-admin-flag.cc0c4adb.js.map
